import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/dashboard",
      meta: {main_page: true},
      component: () => import("@/core/plugins/TitleRibbon/index"),
      children: [
        {
          path: "/dashboard",
          name: "dashboard",
          meta: {main_page: true},
          component: () => import("@/core/plugins/TitleRibbon/Dashboard"),
        },{
          path: "/shortlink",
          name: "shortlink",
          component: () => import("./view/pages/new/showShortLink2.vue"),
          meta: {title: "لیست لینک های من", has_ribbon: true, permission: "shortlink"},

        },
        // {
        //   path: "/new",
        //   name: "new-short-link",
        //   props: true,
        //   component: () => import("./view/pages/new/addShortlink.vue"),

        //   meta: {title: "افزودن لینک کوتاه", has_ribbon: true},
        // },
                {
          path: "/newshortlink",
          name: "new-single-short-link",
          props: true,
          component: () => import("./view/pages/new/addNewSingleShortLink.vue"),
          meta: {title: "ساخت تکی لینک کوتاه", has_ribbon: true, permission: "newshortlink"},
        },
        {
          path: "/newgroupshortlink",
          name: "new-group-short-link",
          props: true,
          component: () => import("./view/pages/new/addNewGroupShortLink.vue"),
          meta: {title: "ساخت گروهی لینک کوتاه", has_ribbon: true, permission: "newgroupshortlink"},
        },

      ],
    },
  ],
});
